export const headerData = {
  data: [
    {
      img: 'https://static.sadhguru.org/d/46272/1698412736-insight-logo.svg',
      heading: 'Insight',
      subHeading: 'The DNA of Success',
      link: 'sadhguru-academy/insight',
      imgMbl: 'https://static.sadhguru.org/d/46272/1698412736-insight-logo.svg',
    },
    {
      img: 'https://static.sadhguru.org/d/46272/1693555215-brand-insight-logo.svg',
      heading: 'Brand Insight',
      subHeading: 'Decoding Branding',
      link: 'sadhguru-academy/brand-insight',
      imgMbl:
        'https://static.sadhguru.org/d/103645/1691572378-clip-path-group-1.svg',
    },
    {
      img: 'https://static.sadhguru.org/d/46272/1693555217-hinar-logo.svg',
      heading: 'Human Is Not A Resource',
      subHeading: 'Unpacking Human Potential',
      link: 'sadhguru-academy/human-is-not-a-resource',
      imgMbl: 'https://static.sadhguru.org/d/103645/1691572159-a.svg',
    },
    {
      img: 'https://static.sadhguru.org/d/46272/1693555212-famex-logo.svg',
      heading: 'Family Enterprise Excellence',
      subHeading: 'Mapping the Future of your business',
      link: 'sadhguru-academy/family-enterprise-excellence',
      imgMbl: 'https://static.sadhguru.org/d/46272/1693555212-famex-logo.svg',
    },
    {
      img: 'https://static.sadhguru.org/d/46272/1747283217-image-17.png',
      heading: 'Insight In Depth',
      subHeading: '',
      link: 'sadhguru-academy/insight-indepth',
      imgMbl: 'https://static.sadhguru.org/d/46272/1747283217-image-17.png',
    },
    {
      img: 'https://static.sadhguru.org/d/46272/1749234775-harnessingmoneymagic_logo.png',
      heading: 'Harnessing Money Magic',
      subHeading: '',
      link: 'sadhguru-academy/harnessing-money-magic',
      imgMbl: 'https://static.sadhguru.org/d/46272/1749234919-harnessingmoneymagic_logo_mobile.png',
    },
    {
      img: 'https://static.sadhguru.org/d/46272/1752657471-gen-a-entrepreneurship-bootcamp.png',
      heading: 'Gen A Entrepreneurship Bootcamp',
      subHeading: '',
      link: 'sadhguru-academy/gen-a-entrepreneurship-bootcamp',
      imgMbl: 'https://static.sadhguru.org/d/46272/1752657471-gen-a-entrepreneurship-bootcamp.png',
    },
  ],
};
